import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Heart, MessageCircle, UserPlus, Pin } from 'lucide-react';
interface NotificationsPanelProps {
  isOpen: boolean;
  onClose: () => void;
}
const mockNotifications = [{
  id: '1',
  type: 'like',
  user: {
    name: 'Sarah Jenkins',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=100&q=80'
  },
  message: 'liked your pin',
  time: '2m ago',
  pinImage: 'https://images.unsplash.com/photo-1598928506311-c55ded91a20c?auto=format&fit=crop&w=100&q=80'
}, {
  id: '2',
  type: 'follow',
  user: {
    name: 'Marcus Chen',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=100&q=80'
  },
  message: 'started following you',
  time: '1h ago'
}, {
  id: '3',
  type: 'comment',
  user: {
    name: 'Elena Rodriguez',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=100&q=80'
  },
  message: 'commented on your pin',
  time: '3h ago',
  pinImage: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?auto=format&fit=crop&w=100&q=80'
}, {
  id: '4',
  type: 'save',
  user: {
    name: 'David Kim',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=100&q=80'
  },
  message: 'saved your pin',
  time: '5h ago',
  pinImage: 'https://images.unsplash.com/photo-1525498128493-380d1990a112?auto=format&fit=crop&w=100&q=80'
}];
const getIcon = (type: string) => {
  switch (type) {
    case 'like':
      return <Heart className="w-4 h-4 text-red-500 fill-red-500" data-id="element-195" />;
    case 'follow':
      return <UserPlus className="w-4 h-4 text-blue-500" data-id="element-196" />;
    case 'comment':
      return <MessageCircle className="w-4 h-4 text-green-500" data-id="element-197" />;
    case 'save':
      return <Pin className="w-4 h-4 text-purple-500" data-id="element-198" />;
    default:
      return null;
  }
};
export function NotificationsPanel({
  isOpen,
  onClose
}: NotificationsPanelProps) {
  if (!isOpen) return null;
  return <>
      <div className="fixed inset-0 z-40" onClick={onClose} data-id="element-199" />
      <AnimatePresence data-id="element-200">
        <motion.div initial={{
        opacity: 0,
        y: 10,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.95
      }} className="absolute right-0 top-full mt-2 w-80 bg-white rounded-xl shadow-xl border border-gray-100 overflow-hidden z-50" onClick={e => e.stopPropagation()} data-id="element-201">
          <div className="p-4 border-b border-gray-100" data-id="element-202">
            <h3 className="font-bold text-gray-900" data-id="element-203">Notifications</h3>
          </div>

          <div className="max-h-96 overflow-y-auto" data-id="element-204">
            {mockNotifications.map(notif => <button key={notif.id} className="w-full flex items-start gap-3 p-4 hover:bg-gray-50 transition-colors text-left border-b border-gray-50 last:border-0" data-id="element-205">
                <div className="relative" data-id="element-206">
                  <img src={notif.user.avatar} alt={notif.user.name} className="w-10 h-10 rounded-full object-cover" data-id="element-207" />
                  <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-white rounded-full flex items-center justify-center shadow-sm" data-id="element-208">
                    {getIcon(notif.type)}
                  </div>
                </div>
                <div className="flex-1 min-w-0" data-id="element-209">
                  <p className="text-sm text-gray-900" data-id="element-210">
                    <span className="font-semibold" data-id="element-211">{notif.user.name}</span>{' '}
                    <span className="text-gray-600" data-id="element-212">{notif.message}</span>
                  </p>
                  <p className="text-xs text-gray-400 mt-0.5" data-id="element-213">{notif.time}</p>
                </div>
                {notif.pinImage && <img src={notif.pinImage} alt="" className="w-10 h-10 rounded-lg object-cover" data-id="element-214" />}
              </button>)}
          </div>

          <div className="p-3 border-t border-gray-100" data-id="element-215">
            <button className="w-full py-2 text-sm font-semibold text-gray-600 hover:text-black transition-colors" data-id="element-216">
              See all notifications
            </button>
          </div>
        </motion.div>
      </AnimatePresence>
    </>;
}